import { api } from "@/lib/api";

/** Default expense buckets shown when the Chart of Accounts has no expense-type
 *  accounts yet (fresh org). Keeping Uncategorized last for fallthrough. */
export const DEFAULT_EXPENSE_CATEGORIES = [
    "Meals", "Travel", "Software", "Office Supplies", "Utilities",
    "Marketing", "Professional Services", "Rent", "Salaries",
    "Other", "Uncategorized",
];

/** Fetch the current org's expense-type Chart of Accounts entries and return
 *  their display names. Names are de-duped and alphabetised for the dropdown.
 *  If none exist (or the call fails) fall back to DEFAULT_EXPENSE_CATEGORIES.
 */
export async function loadExpenseCategories() {
    try {
        const { data } = await api.get("/accounts");
        const names = (data.items || [])
            .filter((a) => a.type === "expense" && !a.archived)
            .map((a) => a.name)
            .filter(Boolean);
        const unique = Array.from(new Set(names)).sort((a, b) => a.localeCompare(b));
        if (unique.length > 0) {
            // Always keep Uncategorized as an option even if the CoA omitted it.
            if (!unique.includes("Uncategorized")) unique.push("Uncategorized");
            return unique;
        }
    } catch (e) {
        // swallow — fall back to defaults below
    }
    return [...DEFAULT_EXPENSE_CATEGORIES];
}
